import { render } from "./kycSuccess.vue?vue&type=template&id=46c66f70&scoped=true&lang=true"
import script from "./kycSuccess.vue?vue&type=script&lang=js"
export * from "./kycSuccess.vue?vue&type=script&lang=js"

import "./kycSuccess.vue?vue&type=style&index=0&id=46c66f70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c66f70"]])

export default __exports__